import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { Customers } from '../_models/customers';
import { User } from '../_models/user';
import { Globals } from '../_globals/globals';


@Injectable({
  providedIn: 'root'
})

export class CustomersService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  /*getAllCustomerss() {
    this.http.get(this.globals.apiUrl + '/customerss')
      .subscribe(customerss => {
        this.customerss = customerss;
      });
  }*/

  getCustomerss(searchParams): Observable<Customers[]> {

    console.log('-->--> Ejecutando servicio getCustomerss.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Customers[]>(this.globals.apiUrl + '/customerss', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getCustomerss: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Customers[]>('getCustomerss', [])
      ));
  }

  getAllCustomerss(): Observable<Customers[]> {

    console.log('-->--> Ejecutando servicio getAllCustomerss');

    return this.http.get<Customers[]>(this.globals.apiUrl + '/customerss')
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAllCustomerss: ' + JSON.stringify(data))),
        catchError(this.handleError<Customers[]>('getAllCustomerss', [])
      ));
  }

  getCustomers(searchParams): Observable<Customers> {

    console.log('-->--> Ejecutando servicio getCustomers');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('id', searchParams.id)
    };
    return this.http.get<Customers>(this.globals.apiUrl + '/customers', options)
      .pipe(
        tap(  _ => this.log('get customers')),
        catchError(this.handleError<Customers>('getCustomers', null)
      ));
  }

  updateCustomers(customersIn: Customers): Observable<Customers> {

    console.log('-->--> Ejecutando servicio updateCustomers');
    console.log(customersIn);
    console.log('---------------');

    let options = {};
    if (customersIn.id === null) {
      options = { params: new HttpParams()
        .set('id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('id', customersIn.id.toString()) };
    }

    return this.http.put<Customers>(this.globals.apiUrl + '/customers', customersIn, options)
      .pipe(
        tap(  _ => this.log('updated customers')),
        catchError(this.handleError<Customers>('updateCustomers', null)
      ));
  }

  createCustomers(customersIn: Customers): Observable<Customers> {

    console.log('-->--> Ejecutando servicio createCustomers');
    console.log(customersIn);
    console.log('---------------');

    let options = {};

    return this.http.post<Customers>(this.globals.apiUrl + '/customers', customersIn, options)
      .pipe(
        tap(  _ => this.log('created customers')),
        catchError(this.handleError<Customers>('createCustomers', null)
      ));
  } // End function createCustomers

  deleteCustomers(customersIn: Customers): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteCustomers');
    console.log(customersIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', customersIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/customers', options)
      .pipe(
        tap(  _ => this.log('deleted customers')),
        catchError(this.handleError<bigint>('deleteCustomers', null)
      ));
  } // End function deleteCustomers

  // -------------------------

  // Servicio para obtener los agentes comerciales.
  getUsers(): Observable<User[]> {

    console.log('-->--> Ejecutando servicio getUsers');

    return this.http.get<User[]>(this.globals.apiUrl + '/users')
      .pipe(
        tap( data => console.log(' -> Comerciales obtenidos desde getUsers.')),
        catchError(this.handleError<User[]>('getUsers', [])
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
